import {
  IconButton,
  TableCell,
  TableRow,
  Theme,
  useTheme,
} from "@material-ui/core";
import { memo, useState, useCallback } from "react";
import { Confirm, useRefresh } from "react-admin";
import {
  ExceptionViewDto,
  HosLogsApiFactory,
} from "../../../../common/data/service-proxies";
import DeleteIcon from "@material-ui/icons/Delete";
import { useAxiosInstance } from "../../../../common/hooks/useAxiosInstance";
import { useActionPermissions } from "../../../../common/auth/useActionPermissions";
import permissionNames from "../../../../common/auth/access-control/permissionNames";

interface Props {
  exception: ExceptionViewDto;
}

export const DriverLogExceptionViewRow = ({ exception }: Props) => {
  const [confirmOpen, setConfirmOpen] = useState<boolean>(false);
  const theme: Theme = useTheme();
  const permissions = useActionPermissions();
  const axios = useAxiosInstance();
  const refresh = useRefresh();
  const handleDelete = useCallback(() => {
    if (!exception?.id) {
      return;
    }

    if (!axios) {
      console.error("No axios present");
      return;
    }

    let shouldRefresh = false;
    HosLogsApiFactory(undefined, axios.defaults.baseURL, axios)
      .apiAppHoslogsRemoveexceptionIdDelete(exception.id)
      .then(() => (shouldRefresh = true))
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setConfirmOpen(false);
        if (shouldRefresh) {
          refresh();
        }
      });
  }, [axios, exception.id, refresh]);

  const ConfirmDelete = memo(() => {
    return (
      <Confirm
        isOpen={confirmOpen}
        title="resources.hos-driver-log-view.labels.confirmDeleteExceptionTitle"
        content="resources.hos-driver-log-view.labels.confirmDeleteExceptionMessage"
        onConfirm={handleDelete}
        onClose={() => setConfirmOpen(false)}
      />
    );
  });

  return (
    <TableRow key={exception.id}>
      <TableCell>{exception.country}</TableCell>
      <TableCell>{exception.exception}</TableCell>
      {permissions && permissions[permissionNames.hos.logs.addException] ? (
        <TableCell>
          <IconButton
            style={{ color: theme.palette.error.main }}
            onClick={(e) => {
              setConfirmOpen(true);
              e.stopPropagation();
            }}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      ) : null}
      <ConfirmDelete />
    </TableRow>
  );
};
